import React, { FunctionComponent } from "react";
import { Box } from "theme-ui";
import { FluidImage as ImageType } from '@codersclan/gatsby-theme-airfleet/src/@types';

interface BackgroundProps {
  background: {
    backgroundSettings: {
      attachment: string;
      image: ImageType;
      mixBlendMode: string;
      repeat: string;
      size: string;
      position: {
        x: string;
        y: string;
      };
    };
  };
}

const Background: FunctionComponent<BackgroundProps> = ({ background, children }) => {
  const {
    attachment,
    mixBlendMode,
    image,
    position,
    repeat,
    size
  } = background.backgroundSettings;

  return (
    <Box
      className="custom-background-section"
      sx={{
        backgroundAttachment: attachment,
        backgroundBlendMode: mixBlendMode,
        backgroundImage: `url(${image?.localFile?.publicURL || ''})`,
        backgroundPositionX: position.x,
        backgroundPositionY: position.y,
        backgroundRepeat: repeat ? 'repeat' : 'no-repeat',
        backgroundSize: size
      }}
    >{children}</Box>
  );
}


export default Background;
